import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_14: FaireProductEntity = {
  token: "toysmith-14",
  type: "product",
  name: "Can You Imagine Air Power Ultraglow Soccer Disk",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/a8c2f722e1e3624bc8b60e7fe8875aac8d7d7967c790b30887577be7b8fd58bc.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=917,918,x0,y41,safe&width=720",
  priceDollars: 12,
  msrpDollars: 24,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
